import {
  BLOCK_DATE_SELECTION,
  SET_FLIGHT_VIEW_MODE,
  DISMISS_NO_DIRECTS_MESSAGE,
} from '../helpers/constants/actionsConstants';

import type {
  BlockDateSelectionAction,
  DismissNoDirectsMessageAction,
  SetFlightViewModeAction,
} from './types';

const setFlightViewMode = (mode: string): SetFlightViewModeAction => ({
  type: SET_FLIGHT_VIEW_MODE,
  payload: { mode },
  meta: {
    googleAnalyticsLogEvent: SET_FLIGHT_VIEW_MODE,
  },
});

const blockDateSelection = (): BlockDateSelectionAction => ({
  type: BLOCK_DATE_SELECTION,
});

const dismissNoDirectsMsg = (): DismissNoDirectsMessageAction => ({
  type: DISMISS_NO_DIRECTS_MESSAGE,
});

export { blockDateSelection, setFlightViewMode, dismissNoDirectsMsg };
